/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: TaskMapEncoder
// source: tasks/**
// passthrough: @pdfking/planner/tasks

import { TaskExec, TaskIO } from "@pdfking/planner"
import type { ZipInput } from "../tasks/TaskZip"
import type { Pixel } from "@pdfking/math"
import type { Page, PageNumber } from "@pdfking/renderer-api"
import type { StringGUID } from "@pdfking/tfunc"
import type { BinaryPagePdf, FileIdmlPlottingContext, FilePlottingContext, PdfEngineOptions, RemoteFile, SinglePagePdf, SinglePageTask, VirtualFile } from "#public"
import type { TaskConvert as TaskConvertType } from "../tasks/TaskConvert"
import type { TaskJson as TaskJsonType } from "../tasks/TaskJson"
import type { TaskMerge as TaskMergeType } from "../tasks/TaskMerge"
import type { TaskPlot as TaskPlotType } from "../tasks/TaskPlot"
import type { TaskPlotIdml as TaskPlotIdmlType } from "../tasks/TaskPlotIdml"
import type { TaskSplit as TaskSplitType } from "../tasks/TaskSplit"
import type { TaskZip as TaskZipType } from "../tasks/TaskZip"
import type { TasksType as TT1 } from "@pdfking/planner/tasks"
import { Tasks as T1, TasksDescriptor as D1 } from "@pdfking/planner/tasks"
import { RecordMerge } from "@pdfking/tfunc"

const TaskConvert = (...args: Parameters<typeof TaskConvertType>) => import("../tasks/TaskConvert").then(({ TaskConvert }) => TaskConvert(...args))

async function* TaskJson(...args: Parameters<typeof TaskJsonType>) {
  yield* (await import("../tasks/TaskJson")).TaskJson(...args)
}

const TaskMerge = (...args: Parameters<typeof TaskMergeType>) => import("../tasks/TaskMerge").then(({ TaskMerge }) => TaskMerge(...args))
const TaskPlot = (...args: Parameters<typeof TaskPlotType>) => import("../tasks/TaskPlot").then(({ TaskPlot }) => TaskPlot(...args))
const TaskPlotIdml = (...args: Parameters<typeof TaskPlotIdmlType>) => import("../tasks/TaskPlotIdml").then(({ TaskPlotIdml }) => TaskPlotIdml(...args))

async function* TaskSplit(...args: Parameters<typeof TaskSplitType>) {
  yield* (await import("../tasks/TaskSplit")).TaskSplit(...args)
}

const TaskZip = (...args: Parameters<typeof TaskZipType>) => import("../tasks/TaskZip").then(({ TaskZip }) => TaskZip(...args))

export type TasksType = TT1 & {
  TaskConvert: (props: { options: PdfEngineOptions; batch: number }, input: VirtualFile) => Promise<BinaryPagePdf>
  TaskJson: (props: { options: PdfEngineOptions; batch: number }, input: VirtualFile) => AsyncGenerator<SinglePagePdf>
  TaskMerge: (props: { options: PdfEngineOptions; page_count: PageNumber; hash: StringGUID }, input: AsyncGenerator<SinglePagePdf>) => Promise<RemoteFile>
  TaskPlot: (props: {
    options: PdfEngineOptions
    page: Page
    context: FilePlottingContext
    dpi?: Pixel
    hash: StringGUID
  }) => Promise<SinglePageTask>
  TaskPlotIdml: (props: { options: PdfEngineOptions; pages: Page[]; context: FileIdmlPlottingContext }) => Promise<RemoteFile>
  TaskSplit: (props: { options: PdfEngineOptions; start_page: PageNumber; end_page: PageNumber; batch: number }, input: VirtualFile) => AsyncGenerator<BinaryPagePdf>
  TaskZip: (props: { options: PdfEngineOptions; hash: StringGUID }, input: AsyncGenerator<ZipInput>) => Promise<RemoteFile>
}

export const TasksDescriptor = RecordMerge(D1, {
  TaskConvert: { input: TaskIO.ATOM, output: TaskIO.ATOM, exec: TaskExec.CACHED, props: true },
  TaskJson: { input: TaskIO.ATOM, output: TaskIO.STREAM, exec: TaskExec.CACHED, props: true },
  TaskMerge: { input: TaskIO.STREAM, output: TaskIO.ATOM, exec: TaskExec.CACHED, props: true },
  TaskPlot: { input: TaskIO.ATOM, output: TaskIO.ATOM, exec: TaskExec.CACHED, props: true },
  TaskPlotIdml: { input: TaskIO.ATOM, output: TaskIO.ATOM, exec: TaskExec.CACHED, props: true },
  TaskSplit: { input: TaskIO.ATOM, output: TaskIO.STREAM, exec: TaskExec.CACHED, props: true },
  TaskZip: { input: TaskIO.STREAM, output: TaskIO.ATOM, exec: TaskExec.CACHED, props: true },
} as const)

export const Tasks: typeof T1 & {
  TaskConvert: typeof TaskConvert
  TaskJson: typeof TaskJson
  TaskMerge: typeof TaskMerge
  TaskPlot: typeof TaskPlot
  TaskPlotIdml: typeof TaskPlotIdml
  TaskSplit: typeof TaskSplit
  TaskZip: typeof TaskZip
} = RecordMerge(T1, {
  TaskConvert,
  TaskJson,
  TaskMerge,
  TaskPlot,
  TaskPlotIdml,
  TaskSplit,
  TaskZip,
})
